webpackJsonp([262252016866534],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var items = _ref.items,
	      columns = _ref.columns,
	      spacing = _ref.spacing,
	      mb = _ref.mb,
	      rest = _objectWithoutProperties(_ref, ["items", "columns", "spacing", "mb"]);
	
	  var viewItems = items.map(function (item, i) {
	    return _react2.default.createElement(
	      _rebass.Box,
	      { w: 1 / (columns || 4), p: spacing, mb: mb, key: i },
	      item
	    );
	  });
	
	  return _react2.default.createElement(
	    _rebass.Flex,
	    _extends({ w: "100%", wrap: true }, rest),
	    viewItems
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  div:first-child {\n    margin-right: 1rem;\n    font-weight: bold;\n  }\n"], ["\n  display: flex;\n  div:first-child {\n    margin-right: 1rem;\n    font-weight: bold;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rebass = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactComponentQueries = __webpack_require__(9);
	
	var _reactComponentQueries2 = _interopRequireDefault(_reactComponentQueries);
	
	var _redux = __webpack_require__(11);
	
	var _grid = __webpack_require__(52);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _image = __webpack_require__(20);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _utils = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Caption = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var componentQuery = function componentQuery(_ref, props) {
	  var width = _ref.width;
	  var orientation = props.theme.orientation;
	  var overrideColumns = props.overrideColumns;
	
	  var layoutProps = function mapWidthToLayoutProps() {
	    var dFault = {
	      columns: overrideColumns || orientation.vertical ? 1 : 2,
	      spacing: orientation.vertical ? 1 : 5,
	      mb: orientation.vertical ? 10 : 5,
	      image: {
	        ratio: orientation.vertical ? 1 / 2 : 2 / 3
	      },
	      caption: {
	        mt: 8,
	        f: orientation.vertical ? 11 : 9
	      }
	    };
	
	    if (width > 1500) {
	      return _extends({}, dFault, {
	        image: {
	          ratio: 2 / 3
	        },
	        columns: overrideColumns || orientation.vertical ? 2 : 4,
	        spacing: orientation.vertical ? 2 : 1,
	        mb: orientation.vertical ? 3 : 2,
	        caption: {
	          mt: 2,
	          f: orientation.vertical ? 6 : 5
	        }
	      });
	    }
	
	    if (width > 1000) {
	      return _extends({}, dFault, {
	        image: {
	          ratio: 2 / 3
	        },
	        columns: overrideColumns || orientation.vertical ? 2 : 3,
	        spacing: orientation.vertical ? 3 : 2,
	        mb: orientation.vertical ? 3 : 2,
	        caption: {
	          mt: 3,
	          f: orientation.vertical ? 7 : 6
	        }
	      });
	    }
	
	    if (width > 700) {
	      return _extends({}, dFault, {
	        image: {
	          ratio: 2 / 3
	        },
	        columns: orientation.vertical ? 2 : 3,
	        spacing: orientation.vertical ? 3 : 2,
	        mb: orientation.vertical ? 3 : 1,
	        caption: {
	          mt: 5,
	          f: orientation.vertical ? 8 : 7
	        }
	      });
	    }
	
	    if (width > 500) {
	      return _extends({}, dFault, {
	        caption: {
	          mt: 6,
	          f: orientation.vertical ? 9 : 8
	        }
	      });
	    }
	
	    return dFault;
	  }();
	
	  return {
	    layoutProps: layoutProps
	  };
	};
	
	exports.default = (0, _redux.compose)(_styledComponents.withTheme, (0, _reactComponentQueries2.default)(componentQuery))(function (_ref2) {
	  var projects = _ref2.projects,
	      onProjectClick = _ref2.onProjectClick,
	      layoutProps = _ref2.layoutProps;
	  var columns = layoutProps.columns,
	      f = layoutProps.f,
	      mb = layoutProps.mb,
	      spacing = layoutProps.spacing;
	
	  var projectThumbnails = projects.map(function (project) {
	    console.log(project.metadata);
	    var dates = project.metadata.filter(function (md) {
	      return md.itemType === "date";
	    }).map(function (_ref3) {
	      var date = _ref3.value;
	      return (0, _utils.formatDate)(date);
	    }).join(" – ");
	    return _react2.default.createElement(
	      _rebass.Box,
	      { onClick: onProjectClick, key: project.slug, mb: mb },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/projecten/" + project.slug },
	        _react2.default.createElement(_image2.default, {
	          background: true,
	          ratio: layoutProps.image.ratio,
	          file: project.bannerImage
	        })
	      ),
	      _react2.default.createElement(
	        Caption,
	        layoutProps.caption,
	        _react2.default.createElement(
	          "div",
	          null,
	          project.title
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          dates
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(_grid2.default, { items: projectThumbnails, spacing: spacing, f: f, columns: columns });
	});
	module.exports = exports["default"];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridStyled = __webpack_require__(208);
	
	var _lodash = __webpack_require__(29);
	
	var _meta = __webpack_require__(55);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _overlay = __webpack_require__(34);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _projectgrid = __webpack_require__(53);
	
	var _projectgrid2 = _interopRequireDefault(_projectgrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var _props$data = props.data,
	      allProject = _props$data.allProject,
	      globalSeo = _props$data.globalSeo;
	
	  var projects = (0, _lodash.chain)(allProject.edges).map(function (_ref) {
	    var node = _ref.node;
	    return node;
	  }).sortBy(function (p) {
	    var date = p.metadata.find(function (m) {
	      return m.itemType === "date";
	    });
	    if (date) {
	      return date.value;
	    }
	    return p.updatedAt;
	  }).reverse().value();
	  return _react2.default.createElement(
	    _gridStyled.Flex,
	    { w: "100%" },
	    _react2.default.createElement(_meta2.default, globalSeo),
	    _react2.default.createElement(_overlay2.default, { elements: [["RO"], ["Projecten"], ["&"], ["AD"]] }),
	    _react2.default.createElement(_projectgrid2.default, { projects: projects })
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.formatDate = undefined;
	
	var _dateformat = __webpack_require__(81);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint import/prefer-default-export: off */
	var formatDate = exports.formatDate = function formatDate(datestr) {
	  return (0, _dateformat2.default)(new Date(datestr), "mmm yyyy");
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projecten-js-d7c879b2804fb2f0347b.js